'use strict';
angular.module('schoolLinqApp').directive('rcDroplist', function () {
	return {
		require: ['ngModel'],
		scope: {
			labelName: '@',
			options: '=',
			ngModel: '=',
		},
		replace: true,
		restrict: 'E',
		template: require('@ajs/templates/reports/rcDroplist.html'),
		controller: [
			'$scope',
			'$element',
			function ($scope, $element) {
				$scope.isOpen = false;
				$scope.click = function (option) {
					$scope.ngModel = option;
					$scope.isOpen = false;
				};
			},
		],
	};
});
